import { usePatientViewWaitingProviders } from '../usePatientViewWaitingProviders';
import {
  useChatMessagesToast,
  type UseChatMessagesToastProps,
} from './useChatMessagesToast';

type UsePatientChatMessagesToastProps = Omit<
  UseChatMessagesToastProps,
  'findSender'
>;

export const usePatientChatMessagesToast = (
  props: UsePatientChatMessagesToastProps,
) => {
  const { waitingProviders } = usePatientViewWaitingProviders();
  return useChatMessagesToast({
    ...props,
    findSender: (message) =>
      waitingProviders.find(
        (provider) => provider.chatUserId === message.senderId,
      ),
  });
};
